import { getAIRunsUsage } from '@gonfalon/openapi/operations/getAIRunsUsage';
import { getContextsClientsideUsage } from '@gonfalon/openapi/operations/getContextsClientsideUsage';
import { getContextsServersideUsage } from '@gonfalon/openapi/operations/getContextsServersideUsage';
import { getContextsTotalUsage } from '@gonfalon/openapi/operations/getContextsTotalUsage';
import { getDataExportEventsUsage } from '@gonfalon/openapi/operations/getDataExportEventsUsage';
import { getDataExportSourceCapabilities } from '@gonfalon/openapi/operations/getDataExportSourceCapabilities';
import { getExperimentationEventsUsage } from '@gonfalon/openapi/operations/getExperimentationEventsUsage';
import { getExperimentationKeysUsage } from '@gonfalon/openapi/operations/getExperimentationKeysUsage';
import { getExperimentExposureActive } from '@gonfalon/openapi/operations/getExperimentExposureActive';
import { getMAUClientsideUsage } from '@gonfalon/openapi/operations/getMAUClientsideUsage';
import { getMAUTotalUsage } from '@gonfalon/openapi/operations/getMAUTotalUsage';
import { getObservabilityErrorsUsage } from '@gonfalon/openapi/operations/getObservabilityErrorsUsage';
import { getObservabilityLogsUsage } from '@gonfalon/openapi/operations/getObservabilityLogsUsage';
import { getObservabilityMetricsUsage } from '@gonfalon/openapi/operations/getObservabilityMetricsUsage';
import { getObservabilitySessionsUsage } from '@gonfalon/openapi/operations/getObservabilitySessionsUsage';
import { getObservabilityTracesUsage } from '@gonfalon/openapi/operations/getObservabilityTracesUsage';
import { getSdkActive } from '@gonfalon/openapi/operations/getSdkActive';
import { getSdkVersionsDetails } from '@gonfalon/openapi/operations/getSdkVersionsDetails';
import { getServiceConnectionsUsage } from '@gonfalon/openapi/operations/getServiceConnectionsUsage';
import { getStreamUsage } from '@gonfalon/openapi/operations/getStreamUsage';
import { getStreamUsageBySdkVersion } from '@gonfalon/openapi/operations/getStreamUsageBySdkVersion';
import { getVegaAIUsage } from '@gonfalon/openapi/operations/getVegaAIUsage';
import { getWarehouseExportUsage } from '@gonfalon/openapi/operations/getWarehouseExportUsage';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getServiceConnectionsUsageQuery = createQueryOptions(getServiceConnectionsUsage);
export const getMAUClientsideUsageQuery = createQueryOptions(getMAUClientsideUsage);
export const getDataExportEventsUsageQuery = createQueryOptions(getDataExportEventsUsage);
export const getWarehouseExportUsageQuery = createQueryOptions(getWarehouseExportUsage);
export const getDataExportSourceCapabilitiesQuery = createQueryOptions(getDataExportSourceCapabilities);
export const getExperimentationKeysUsageQuery = createQueryOptions(getExperimentationKeysUsage);
export const getExperimentationEventsUsageQuery = createQueryOptions(getExperimentationEventsUsage);
export const getMAUTotalUsageQuery = createQueryOptions(getMAUTotalUsage);
export const getSdkActiveQuery = createQueryOptions(getSdkActive);
export const getExperimentExposureActiveQuery = createQueryOptions(getExperimentExposureActive);
export const getSdkVersionsDetailsQuery = createQueryOptions(getSdkVersionsDetails);
export const getContextsTotalUsageQuery = createQueryOptions(getContextsTotalUsage);
export const getContextsClientsideUsageQuery = createQueryOptions(getContextsClientsideUsage);
export const getContextsServersideUsageQuery = createQueryOptions(getContextsServersideUsage);
export const getObservabilitySessionsUsageQuery = createQueryOptions(getObservabilitySessionsUsage);
export const getObservabilityErrorsUsageQuery = createQueryOptions(getObservabilityErrorsUsage);
export const getObservabilityLogsUsageQuery = createQueryOptions(getObservabilityLogsUsage);
export const getObservabilityTracesUsageQuery = createQueryOptions(getObservabilityTracesUsage);
export const getObservabilityMetricsUsageQuery = createQueryOptions(getObservabilityMetricsUsage);
export const getVegaAIUsageQuery = createQueryOptions(getVegaAIUsage);
export const getAIRunsUsageQuery = createQueryOptions(getAIRunsUsage);
export const getStreamUsageQuery = createQueryOptions(getStreamUsage);

// V1 usage APIs with limited functionality
const getClientConnectionsUsage = (params: Parameters<typeof getStreamUsage>[0]) =>
  getStreamUsage({ ...params, source: 'client' });

const getPeakConcurrentConnectionsUsage = (params: Parameters<typeof getStreamUsage>[0]) =>
  getStreamUsage({ ...params, source: 'server' });

const getPeakConcurrentConnectionsUsageBySdkVersion = (params: Parameters<typeof getStreamUsageBySdkVersion>[0]) =>
  getStreamUsageBySdkVersion({ ...params, source: 'server' });

export const getClientConnectionsUsageQuery = createQueryOptions(getClientConnectionsUsage);
export const getPeakConcurrentConnectionsUsageQuery = createQueryOptions(getPeakConcurrentConnectionsUsage);
export const getPeakConcurrentConnectionsUsageBySdkVersionQuery = createQueryOptions(
  getPeakConcurrentConnectionsUsageBySdkVersion,
);
